import React from 'react';
import { translateText, translateTextHtml } from '../../../getTranslationsMyProfileUploadDocumentation';

export const UploadTips = () => {
    return (
        <div className="upload-tips">
            <p>{translateTextHtml('uploadUpToDocuments')}</p>
            <p>{translateText('tipsExtension')}</p>
        </div>
    );
};
